module.exports = __webpack_public_path__ + "img/voice-thumb5.874e78b.jpg";